import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Reveel - AI Skin Score & Glow',
  description = 'Daily selfie. Real skin results. Reveel scores your skin on 10 metrics, prescribes a routine built for YOUR face, and tracks real progress from day 1.',
  url = 'https://reveel.health',
  image = 'https://lllqncjwqcbrygqujdin.supabase.co/storage/v1/object/public/media/logo512.png',
  type = 'website',
  keywords = 'skin, glow, skincare, skin analysis, skin score, skin age, face scan, acne, wrinkles, routine, ai, beauty'
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Reveel",
    "applicationCategory": "LifestyleApplication",
    "operatingSystem": "iOS",
    "description": description,
    "url": url,
    "image": image,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "10000"
    },
    "author": {
      "@type": "Organization",
      "name": "Reveel",
      "url": "https://reveel.health"
    }
  };

  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Reveel",
    "url": "https://reveel.health",
    "logo": "https://lllqncjwqcbrygqujdin.supabase.co/storage/v1/object/public/media/logo512.png",
    "sameAs": [
      "https://twitter.com/reveelhealth",
      "https://instagram.com/reveelhealth"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "hello@reveel.health",
      "contactType": "customer service"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "231 Avenue du Faubourg Saint-Honore",
      "addressLocality": "Paris",
      "postalCode": "75001",
      "addressCountry": "FR"
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Reveel" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Reveel" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@reveelhealth" />
      <meta name="twitter:creator" content="@reveelhealth" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
    </Helmet>
  );
};

export default SEO;
